export default __webpack_public_path__ + "static/media/blog-post-2.b69dc5dc.jpg";